import {
    CsvInteractionExportField
} from '../../../Discover/Targeting/components/TargetingResults/CsvInteractionExportDialog/csv-interaction-export-field.enum';
import {
    CsvInteractionExportType
} from '../../../Discover/Targeting/components/TargetingResults/CsvInteractionExportDialog/csv-interaction-export-type.enum';
import { SearchRangeResponseItemApiModel } from '../../mercury/model/search-range-response-item-api.model';
import { EntityIdApiModel } from './entity-id-api-model';
import { TargetingQueryApi } from './targeting-search.api.model';

export class InteractionsExportApi {
    dateRange: SearchRangeResponseItemApiModel;
    types: CsvInteractionExportType[];
    fields: CsvInteractionExportField[];
    entityIds?: EntityIdApiModel[];
    query?: TargetingQueryApi;
    isAllInteractions?: boolean;
}
